module.exports = __webpack_public_path__ + "img/BYD-Atto-3-Extended-Range.5da95fee.png";